// Helpers
import { getPayPlansEditAccess } from "@/Common/helpers/Positions/positionsAccess";

// API's
// Advisors Queries
import {
	getAdvisorPayPlan,
	getAdvisorPayPlans,
	getAdvisorPayPlanMatches,
	getAdvisorPayPlansSidebarTree,
} from "@/PayPlans/api/advisors/queries";

// Advisors Mutations
import {
	createAdvisorPayPlan,
	saveNewAdvisorPayPlan,
	cloneAdvisorPayPlan,
	updateAdvisorPayPlan,
	updateAdvisorAvailablePayPlan,
	deleteAdvisorPayPlan,
} from "@/PayPlans/api/advisors/mutations";

// Advisors Subscriptions
import {
	onCloneAdvisorPayPlan,
	onCreateAdvisorPayPlan,
	onDeleteAdvisorPayPlan,
	onUpdateAdvisorPayPlan,
	onUpdateAdvisorAvailablePayPlan,
} from "@/PayPlans/api/advisors/subscriptions";

const getAdvisorEditAccess = (position) => getPayPlansEditAccess(position);

const getAdvisorsServices = (position) => {
	// Auth actions
	const actions = {
		editable: getAdvisorEditAccess(position),
	};

	const getPayPlan = async (locationId, id, extraPosition) => getAdvisorPayPlan(locationId, id, extraPosition || position);
	const getMatches = async (locationId, id, extraPosition) => getAdvisorPayPlanMatches(locationId, id, extraPosition || position);

	// API Queries
	const queries = {
		getPayPlan,
		getMatches,
		getPayPlans: getAdvisorPayPlans,
		getPayPlansSidebarTree: getAdvisorPayPlansSidebarTree,
	};

	// API Mutations
	const mutations = {
		addPayPlan: createAdvisorPayPlan,
		saveNewPayPlan: saveNewAdvisorPayPlan,
		updatePayPlan: updateAdvisorPayPlan,
		deletePayPlan: deleteAdvisorPayPlan,
		clonePayPlan: cloneAdvisorPayPlan,
		updateAvailablePayPlan: updateAdvisorAvailablePayPlan,
	};

	// API Subscriptions
	const subscriptions = new Map([
		["onClonePayPlan", { query: onCloneAdvisorPayPlan, getter: "onCloneAdvisorPayPlan" }],
		["onCreatePayPlan", { query: onCreateAdvisorPayPlan, getter: "onCreateAdvisorPayPlan" }],
		["onDeletePayPlan", { query: onDeleteAdvisorPayPlan, getter: "onDeleteAdvisorPayPlan" }],
		["onUpdatePayPlan", { query: onUpdateAdvisorPayPlan, getter: "onUpdateAdvisorPayPlan" }],
		["onUpdateAnyPayPlan", { query: "", getter: "" }],
		["onUpdateAvailablePayPlan", { query: onUpdateAdvisorAvailablePayPlan, getter: "onUpdateAdvisorAvailablePayPlan" }],
	]);

	return {
		actions,
		queries,
		mutations,
		subscriptions,
	};
};

export { getAdvisorsServices };
